import { render, staticRenderFns } from "./CompanyDrawerContactTabPhones.vue?vue&type=template&id=3496e596&scoped=true&"
import script from "./CompanyDrawerContactTabPhones.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerContactTabPhones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496e596",
  null
  
)

export default component.exports